let segments = null;

export default {
  namespaced: true,

  state: {
    userCategory: null,
    schoolChoices: [],
    schools: [],
    scorePer: null,
  },

  getters: {
    userCategory: state => { return state.userCategory },
    schoolChoices: state => { return state.schoolChoices },
    schools: state => { return state.schools },
    scorePer: state => { return state.scorePer },
  },

  actions: {
    async init({dispatch, commit, state, getters}, node) {
      segments = node;
      await segments.ready();

      commit('setUserCategory', segments.userType.getCategory());
      segments.userType.listen(userType => {
        commit('setUserCategory', segments.userType.getCategory());
      }, 'bc-banner');

      commit('setSchoolChoices', segments.schoolChoices.find());
      segments.schoolChoices.listen(schoolChoices => {
        commit('setSchoolChoices', segments.schoolChoices.find());
      }, 'bc-banner');

      commit('setScorePer', segments.scores.getTotalPer());
      segments.scores.listen(scores => {
        commit('setScorePer', segments.scores.getTotalPer());
      }, 'bc-banner');
    },
  },

  mutations: {
    setUserCategory(state, category) {
      state.userCategory = category;
    },
    setSchoolChoices(state, schoolChoices) {
      if (JSON.stringify(schoolChoices) === JSON.stringify(state.schoolChoices)) return;
      state.schoolChoices = schoolChoices;
      const schools = schoolChoices.map(offerId => {
        return offerId.slice(0, 4);
      }).sort((a, b) => { return a > b});
      if (state.schools.length !== schools.length) {
        state.schools = schools;
      } else {
        for (let i = 0, l = schools.length; i < l; i++) {
          if (state.schools.indexOf(schools[i]) === -1) {
            state.schools = schools;
            break;
          }
        }
      }
    },
    setScorePer(state, scorePer) {
      state.scorePer = scorePer;
    },
  },
};



// WEBPACK FOOTER //
// ./src/shared/bc-banner/store/modules/segments.js